import { bus, errorHandler } from '@/utils'

export default {
  name: 'InformationModelDelete',
  beforeDestroy () {
    bus.$off('show-delete-information-model')
  },
  methods: {
    alert (type, message) {
      this.alert$.type = type
      this.alert$.message = message
      this.alert$.show = true
    },
    closePopup () {
      this.loading = false
      this.alert$.show = false
      this.showModal = false
    },
    deleteInformationModel (familyName) {
      return this.$api.removeInfoModel({ familyName })
        .then(() => bus.$emit('get-information-model-list'))
        .then(() => this.successCallback())
        .catch((e) => this.failedCallback(e))
    },
    failedCallback (e) {
      let errorMessage = errorHandler(this.component, e.status)

      errorMessage = typeof errorMessage !== 'string' ? e.body : this.$t(errorMessage)

      this.loading = false
      this.alert('error', errorMessage)
    },
    successCallback () {
      this.closePopup()
      this.$message({
        message: this.$t('messageInformationModelDelete'),
        showClose: true,
        type: 'success'
      })
    }
  },
  data () {
    return {
      alert$: {
        type: '',
        show: false,
        message: ''
      },
      buttons: [
        {
          dataQA: 'Dialog-DeleteInformationModel-Button-Close',
          class: 'btn-close',
          text: 'informationModelDeleteDialogButtonCloseText',
          type: 'text',
          click: () => { this.closePopup() }
        },
        {
          dataQA: 'Dialog-DeleteInformationModel-Button-Delete',
          text: 'informationModelDeleteDialogButtonDeleteText',
          type: 'warning',
          click: () => {
            this.loading = true
            this.deleteInformationModel(this.familyName)
          }
        }
      ],
      component: 'informationModelDelete',
      dialogProps: {
        beforeClose: () => this.closePopup()
      },
      familyName: '',
      loading: false,
      showModal: false
    }
  },
  mounted () {
    bus.$on('show-delete-information-model', ({ show, familyName }) => {
      if (show) {
        this.showModal = true
      }

      if (familyName) {
        this.familyName = familyName
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/InformationModelDelete/InformationModelDelete.js